import {Route,Switch,BrowserRouter } from "react-router-dom";

import DoobiHeader from "components/Headers/DoobiHeader";
import WalletTable from "components/Doobi/Wallet";

const WalletRoute = ({ match }) => {
  return (
    <>
  <DoobiHeader section="Wallet" />
    <BrowserRouter>
    <Switch>
      <Route path={`${match.path}/`} component={WalletTable}/>
    </Switch>
    </BrowserRouter>
    </>
    );
  }; 


export default WalletRoute;
